// This mapping file maps old CP route path to new CP route path.
export const OldRoutesMapping = (oldRoute) => {
    const staticRoutes = {
        '/':'/',
        '/settings': '/account/info',
        '/settings/profile': '/account/info',
        '/logout': '/logout',
        '/settings/events': '/events',
        '/settings/devices': '/account/devices',
        '/settings/security': '/account/security',
        '/settings/branding': '/account/info',
        '/settings/billing': '/account/billing',
        '/settings/billing?newprofile=1': '/account/billing?newprofile=1',
        '/settings/billing?newprofile=0': '/account/billing?newprofile=0',
        '/settings/billing/profile': '/account/billing/profile',
        '/files': '/files',
        '/users': '/multi-user/users',
        '/users/roles': '/multi-user/roles',
        '/shares': '/shares',
        '/shares/invite': '/shares/invite',
        '/shares/externalshares': '/shares/externalshares',
        '/shares/links' : '/links',
        '/recents': '/recents',
        '/starred': '/starred',
        '/setinvitepassword': '/setinvitepassword',
        '/setuserinviteconsent': '/setuserinviteconsent',
        '/verifyemail': '/verifyemail',
        '/vault': '/vault',
        '/comment-iframe/cm': '/comment-iframe/cm',
        '/sso': '/sso',
        '/links': '/shares/links',
        '/settings/upgrade-plan': '/settings/upgrade-plan',
        '/register': '/register',
        '/cancelsub': '/cancelsub',
        '/success': '/success',
        '/pay-invoices': '/pay-invoices',
    };

    const dynamicRoutes = {
        '/users/roles/:id': '/multi-user/roles',
        '/users/roles/:id/edit': '/multi-user/roles',
        '/users/**': '/multi-user/users',
        '/shares\\?loc=**': '/shares?loc=**',
        '/shares/invite/:id': '/shares/invite/:id',
        '/shares/rejoin': '/shares/rejoin',
        '/signup-share/:cachekey': '/signup-share/:cachekey',
        '/file-history/:id':'/file/:id/history',
        '/verifyemail**': '/verifyemail**',
    }

    // Check if the old route matches any of the static routes
    if (staticRoutes[oldRoute]) {
        return staticRoutes[oldRoute];
    }

    // Check if the old route matches any of the dynamic routes
    for (const [key, value] of Object.entries(dynamicRoutes)) {
        let i = 0;
        const patterns = {};
        const pattern = new RegExp(`^${key.replace(/(:\w+|\*\*)/g, (match) => {
            patterns[i++] = match;
            if (match === '**') return '(.*)';
            else return '([^/]+)';
        })}$`);

        const match = oldRoute.match(pattern);

        if (match) {
            let newRoute = value;
            for (let j = 1; j < match.length; ++ j) {
                const a = patterns[j - 1];
                newRoute = value.replace(a, match[j]);
            }

            return newRoute;
        }
    }

    // Handle dynamic routes like /file/:id/view/:type
    const dynamicRoutePattern = /^\/file\/([^/]+)\/view\/([^/]+)$/;
    const match = oldRoute.match(dynamicRoutePattern);

    if (match) {
        const [_, id, type] = match;
        return `/file/${id}/view/${type}`;
    }

    // Handle the new dynamic route with query parameter of share invite
    const sharesInvitePattern = /^\/shares\/invite\?invite_id=(.+)$/;
    const sharesInviteMatch = oldRoute.match(sharesInvitePattern);

    if (sharesInviteMatch) {
        const inviteId = sharesInviteMatch[1];
        return `/shares/invite?invite_id=${inviteId}`;
    }
    

    // Handle the new dynamic route with query parameter
    const sharesRejoinPattern = /^\/shares\/rejoin\?invite_id=(.+)$/;
    const sharesRejoinMatch = oldRoute.match(sharesRejoinPattern);

    if (sharesRejoinMatch) {
        const inviteId = sharesRejoinMatch[1];
        return `/shares/rejoin?invite_id=${inviteId}`;
    }
    // Handle dynamic routes like /vault/:id/view/:type
    const dynamicRoutePatternVault = /^\/vault\/([^/]+)\/view\/([^/]+)$/;
    const vaultMatch = oldRoute.match(dynamicRoutePatternVault);

    if (match) {
        const [_, id, type] = vaultMatch;
        return `/vault/${id}/view/${type}`;
    }

     /*  match routes with QueryParams
        Example 1:
            oldRoute: /setuserinviteconsent?c=xyz
            return: /setuserinviteconsent?c=xyz

        Example 2:
            oldRoute: /account/billing?newprofile=1
            return /settings/billing?newprofile=1
    */
    const pathname = new URL(oldRoute, document.location.href).pathname;
    const newRoutePath = staticRoutes[pathname];
    if (newRoutePath) {
        return oldRoute.replace(pathname, newRoutePath);
    }

    // Return null or handle unmatched routes
    return null;
};